import { render, staticRenderFns } from "./NonPriorityDialog.vue?vue&type=template&id=0c6e0931"
import script from "./NonPriorityDialog.vue?vue&type=script&lang=js"
export * from "./NonPriorityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports